import React from 'react';

export const ResultRank = React.memo(({ result, rank, isUnchecked }) => {
  return (
    <div className='resultRank-result-rank'>
      <div className='resultRank-result'>{isUnchecked ? `(${result})` : result}</div>
      <div className={`${rank ? 'resultRank-rank' : 'resultRank-rank-empty'}`}>{rank}</div>
    </div>
  )
});

export const ResultRankDiff = React.memo(({ result, rank, diff }) => {
  return (
    <>
      <div className='resultRank-result-rank'>
        <div className='resultRank-result'>{result}</div>
        <div className={`${rank ? 'resultRank-rank' : ''}`}>{rank}</div>
      </div>
      <div>
        <div className='resultRank-result'>{diff}</div>
      </div>
    </>
  )
});

export const ResultRankDiffOws = React.memo(({ card, result, rank, diff }) => {
  return (
    <>
      <div className='resultRank-result-rank'>
        <div className='resultRank-result'>{card}&nbsp;{result}</div>
        <div className={`${rank ? 'resultRank-rank' : ''}`}>{rank}</div>
      </div>
      <div>
        <div className='resultRank-result'>{diff}</div>
      </div>
    </>
  )
});

export const ResultCompetitor = React.memo(({ bib, noc, competitor }) => {
  return (
    <>
      <div className='d-flex flex-row'>
        <div className='resultRacefacts-bib pe-2 text-end'>{bib}</div>
        <div className='pe-2 mt-1 d-none d-md-block'>{noc}</div>
        <div className=''>{competitor}</div>
      </div>
    </>
  )
});

export default ResultRank